import React from 'react';
import { useLocation } from 'react-router-dom';
import { useConfiguration } from '../../context/configurationContext';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { matchPathname } from '../../util/routes';
import loadable from '@loadable/component';

import css from './FooterContainer.module.css';

const SectionBuilder = loadable(
  () => import(/* webpackChunkName: "SectionBuilder" */ '../PageBuilder/PageBuilder'),
  {
    resolveComponent: components => components.SectionBuilder,
  }
);

const FooterComponent = () => {
  const { footer = {} } = useConfiguration();
  const routes = useRouteConfiguration();
  const { pathname } = useLocation();

  // If footer asset is not set, let's not render Footer at all.
  if (Object.keys(footer).length === 0) {
    return null;
  }

  // The footer asset does not specify sectionId or sectionType. However, the SectionBuilder
  // expects sectionId and sectionType in order to identify the section. We add those
  // attributes here before passing the asset to SectionBuilder.
  const footerSection = {
    ...footer,
    sectionId: 'footer',
    sectionType: 'footer',
  };

  // En móvil, el área privada (panel, reservas, ajustes...) va sin footer. Se oculta por CSS
  // porque en el SSR no se conoce el ancho de la pantalla.
  const isPrivateRoute = matchPathname(pathname, routes).some(({ route }) => route.auth);
  const sections = <SectionBuilder sections={[footerSection]} />;

  return isPrivateRoute ? <div className={css.hiddenOnMobile}>{sections}</div> : sections;
};

// NOTE: if you want to add dynamic data to FooterComponent,
//       you could just connect this FooterContainer to Redux Store
//
// const mapStateToProps = state => {
//   const { currentUser } = state.user;
//   return { currentUser };
// };
// const FooterContainer = compose(connect(mapStateToProps))(FooterComponent);
// export default FooterContainer;

export default FooterComponent;
